// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"85804576","257":"c4cf4bea","453":"90966f4d","658":"4ee0c6f5","680":"af865321","725":"95a00624","990":"5d0256c6"}[chunkId] + ".chunk.js";
};